import { Button } from "@heroui/button";
import { Code } from "@heroui/code";
import {
	type ErrorResponse,
	isRouteErrorResponse,
	Link,
} from "@remix-run/react";

export function PrettyError({ error }: { error: ErrorResponse | unknown }) {
	if (isRouteErrorResponse(error)) {
		return (
			<div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 p-6">
				<div className="bg-white rounded-lg shadow-lg p-8 text-center">
					<h1 className="text-8xl text-gray-800">:(</h1>
					<p className="mt-4 text-2xl font-semibold text-gray-800">
						Perdón, pero... algo salió bastante mal
					</p>
					<p className="mt-2 text-gray-800">
						Comparte este error con nuestro equipo técnico:
					</p>
					<div className="flex flex-col gap-10 my-5">
						<Code>Status code {error.status}: {error.statusText}</Code>
						<Code className="text-wrap max-w-screen-sm">{JSON.stringify(error.data)}</Code>
					</div>
					<Button color="primary">
						<Link to="/">Volver al inicio</Link>
					</Button>
				</div>
			</div>
		);
	}

	return (
		<div className="min-h-screen flex flex-col items-center justify-center bg-gradient-to-r from-purple-400 via-pink-500 to-red-500 p-6">
			<div className="bg-white rounded-lg shadow-lg p-8 text-center">
				<h1 className="text-8xl text-gray-800">:(</h1>
				<p className="mt-4 text-2xl font-semibold text-gray-800">
					Is anyone there? Oh, hi
				</p>
				<p className="mt-2 text-gray-800">
					Comparte este error con nuestro equipo técnico:
				</p>
				<div className="flex flex-col gap-10 my-5">
					<Code className="text-wrap max-w-screen-sm">{JSON.stringify(error)}</Code>
				</div>
				<Button color="primary">
					<Link to="/">Volver al inicio</Link>
				</Button>
			</div>
		</div>
	);
}
